const FEATURES = [
  {
    icon: 'ri-map-pin-2-line',
    title: 'Real-Time GPS Tracking',
    desc: 'Watch your shipment move on a live map, updated every minute. From pickup to doorstep — never lose visibility.',
  },
  {
    icon: 'ri-notification-3-line',
    title: 'Instant Status Alerts',
    desc: 'SMS and email notifications the moment your shipment status changes. Hold, in transit, out for delivery — you know first.',
  },
  {
    icon: 'ri-route-line',
    title: 'Optimized Routes',
    desc: 'AI-powered route optimization ensures the fastest, most efficient paths for every delivery, saving time and fuel.',
  },
  {
    icon: 'ri-flight-takeoff-line',
    title: 'Air & Ground Freight',
    desc: 'From same-day local couriers to international air cargo — one platform handles it all with seamless handoffs.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Insured Deliveries',
    desc: 'Every shipment is automatically covered. File claims instantly and get reimbursed within 48 hours, guaranteed.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '24/7 Live Support',
    desc: 'Real humans available around the clock. Chat, call, or email — our team resolves issues in under 3 minutes on average.',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-semibold tracking-wider mb-4 border"
            style={{ background: 'var(--primary-light)', borderColor: 'color-mix(in srgb, var(--primary) 30%, transparent)', color: 'var(--primary-dark)' }}
          >
            PLATFORM FEATURES
          </div>
          <h2 className="font-heading font-bold text-4xl md:text-5xl text-gray-900 mb-4">
            Everything You Need to Ship <br />
            <span style={{ color: 'var(--primary)' }}>with Confidence</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            Powerful logistics tools designed for businesses of every size — from solo merchants to enterprise supply chains.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {FEATURES.map(({ icon, title, desc }) => (
            <div
              key={title}
              className="group p-7 rounded-2xl border border-gray-100 bg-white hover:border-transparent transition-all duration-300"
              style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLDivElement).style.boxShadow = '0 12px 40px rgba(13,148,136,0.12)';
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLDivElement).style.boxShadow = '0 1px 3px rgba(0,0,0,0.04)';
              }}
            >
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center mb-5"
                style={{ background: 'var(--primary-light)' }}
              >
                <i className={`${icon} text-2xl`} style={{ color: 'var(--primary)' }} />
              </div>
              <h3 className="font-heading font-semibold text-gray-900 text-lg mb-3">{title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
